var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip:bottom",value:(_vm.tooltip),expression:"tooltip",arg:"bottom"}],staticClass:"label label-default"},[_c('i',{staticClass:"fas fa-question-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }